import React from 'react'
import { useParams } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import messages from './messages'
import styles from './ErrorPage.scss'

export default function ErrorPage() {
  const { errorCode } = useParams()

  return (
    <div className={styles.container}>
      <div className={styles.image}>
        <img src={require('./assets/error.png')} />
      </div>
      <div className={styles.content}>
        <h1 className={styles.header}>{errorCode}</h1>
        <h3 className={styles.message}>
          <FormattedMessage {...messages.errorMessages[`error${errorCode}`]} />
        </h3>
      </div>
    </div>
  )
}
